import { render, staticRenderFns } from "./BatchModifyRecords.vue?vue&type=template&id=59e2ddbb&scoped=true"
import script from "./BatchModifyRecords.vue?vue&type=script&lang=js"
export * from "./BatchModifyRecords.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyRecords.vue?vue&type=style&index=0&id=59e2ddbb&prod&lang=css"
import style1 from "./BatchModifyRecords.vue?vue&type=style&index=1&id=59e2ddbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e2ddbb",
  null
  
)

export default component.exports